<template>
  <v-sheet height="150px" width="100%" v-if="loading">
    <v-row align="center" justify="center" style="height: 100%">
      <v-progress-circular indeterminate></v-progress-circular>
    </v-row>
  </v-sheet>
  <v-row align="stretch" v-else>
    <v-col cols="12" sm="4" xl="3" v-for="item in data" :key="item.id">
      <ProductPreparationSlipItem
        :item="item"
        :recipe="recipe"
      ></ProductPreparationSlipItem>
    </v-col>
  </v-row>
</template>

<script>
import { api } from "@/api";
import { mapGetters } from "vuex";
import ProductPreparationSlipItem from "./ProductPreparationSlipItem";
export default {
  name: "ProductPreparationSlipAdder",
  components: {
    ProductPreparationSlipItem
  },
  props: {
    id: {
      required: true
    },
    recipe: {
      required: true
    }
  },
  mounted() {
    this.getData();
  },
  computed: {
    ...mapGetters(["getPreparationSlipTemplates", "getStoreId"]),
    getFilteredTemplates() {
      return this.getPreparationSlipTemplates.filter(
        x => x.is_deleted === false
      );
    }
  },
  data() {
    return {
      data: [],
      loading: false,
      headers: [
        { value: "name", text: "Gabarit" },
        { value: "sales_target", text: "Ventes" },
        { value: "quantity_min", text: "Quantité minimum" },
        {
          value: "quantity",
          text: "Quantité pour la journée / ou selon les ventes"
        },
        {
          value: "action",
          text: ""
        }
      ]
    };
  },
  methods: {
    async getData() {
      try {
        this.loading = true;
        await this.$store.dispatch("loadPreparationSlipTemplates");
        let d = [
          ...this.getPreparationSlipTemplates.filter(
            x => x.is_deleted === false
          )
        ];
        this.data = d.map(x => {
          const p = this.getProduct(x);
          return {
            ...x,
            isChanged: false,
            quantity_min:
              p !== null && p.quantity_min !== undefined
                ? Number(p.quantity_min)
                : null,
            quantity:
              p !== null && p.quantity !== undefined ? Number(p.quantity) : null
          };
        });
      } finally {
        this.loading = false;
      }
    },
    getProduct(template) {
      const productQty = template.preparation_slip_template_products.find(
        x => x.fk_product === this.id
      );
      if (productQty) return productQty;
      return null;
    },
    async saveTemplateValues(productId) {
      for (let template of this.data.filter(x => x.isChanged === true)) {
        this.loading = true;
        const templateProduct = template.preparation_slip_template_products.find(
          x => x.fk_product === productId
        );
        if (templateProduct !== undefined) {
          const data = {
            ...templateProduct,
            quantity_min: template.quantity_min,
            quantity: template.quantity
          };
          await api.patchPreparationSlipTemplateProduct(data.id, data);
        } else {
          const data = {
            fk_preparation_slip_template: template.id,
            fk_product: productId,
            quantity_min: template.quantity_min,
            quantity: template.quantity,
            force_show: false,
            store: this.getStoreId
          };
          await api.postPreparationSlipTemplateProduct(data);
        }
      }
    }
  }
};
</script>

<style></style>
